
import Collapsible from 'react-collapsible';
import '../../css/CollapsibleDiv.scss';

function CollapsibleDiv(props) {
    return (
      <>
        <Collapsible
            trigger={props.title}
            triggerClassName="CustomTriggerCSS"
            triggerOpenedClassName="CustomTriggerCSS--open"
            contentOuterClassName="CustomOuterContentCSS"
            contentInnerClassName="CustomInnerContentCSS"
        >
            <div dangerouslySetInnerHTML={ props.content} />
        </Collapsible>
      </>
    );
  }
  
export default CollapsibleDiv;